import { render, staticRenderFns } from "./CoinHistory.vue?vue&type=template&id=848c3102&scoped=true&"
import script from "./CoinHistory.vue?vue&type=script&lang=js&"
export * from "./CoinHistory.vue?vue&type=script&lang=js&"
import style0 from "./CoinHistory.vue?vue&type=style&index=0&id=848c3102&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848c3102",
  null
  
)

export default component.exports